import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tenderAmount'
})

export class TenderAmountPipe implements PipeTransform {

  transform(amount: number): string {
    if (amount < 1000) {
      return `₹ ${amount}`;
    } else if (amount >= 1000 && amount <= 100000) {
      let amt = amount / 1000;

      if (Number.isInteger(amt)) {
        return `₹ ${amt} K`;
      } else {
        return `₹ ${amt.toFixed(2)} K`;
      }
    } else if (amount >= 100000 && amount < 10000000) {
      let amt = amount / 100000;

      if (Number.isInteger(amt)) {
        return `₹ ${amt} L`;
      } else {
        return `₹ ${amt.toFixed(2)} L`;
      }
    } else {
      let amt = amount / 10000000;

      if (Number.isInteger(amt)) {
        return `₹ ${amt} Cr`;
      } else {
        return `₹ ${amt.toFixed(2)} Cr`;
      }
    }
  }
}
